import React, { useState, useEffect } from "react";
import { Modal, Input, Table, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { session } from "../../../../services/session";
import { config } from "../../../../config";

const get = async (url) => {
  const token = session.get();
  const headers = {};

  if (token) {
    headers[config.backendTokenKEY] = `Bearer ${token}`;
  }

  return await axios.get(url, { headers });
};

const DirectModal = ({ visible, data, onClose, refetch }) => {
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [headerData, setHeaderData] = useState(null);

  useEffect(() => {
    if (visible && data?.docNum) {
      fetchData();
    }
  }, [visible, data?.docNum]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const url = `https://api.krupasnab.uz/api/Purchase/purchase-invoices-direct?docNum=${data.docNum}`;
      const { data: responseData } = await get(url);

      if (responseData && responseData.length > 0) {
        setHeaderData(responseData[0]);
        setModalData(responseData);
      }
    } catch (error) {
      console.log("Error:", error);
      message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  if (!data || !headerData) return null;

  const columns = [
    {
      title: "Maxsulot",
      dataIndex: "itemName",
      key: "itemName",
      width: 300,
    },
    {
      title: "Miqdor",
      dataIndex: "qty",
      key: "qty",
      width: 150,
      render: (text, record) => {
        const formattedQty = new Intl.NumberFormat("fr-FR").format(text || 0);
        return `${formattedQty} ${record.unitMsr || ""}`;
      },
    },
    // {
    //   title: "Narxi",
    //   dataIndex: "price",
    //   key: "price",
    //   width: 150,
    //   render: (text, record) => {
    //     const formattedPrice = new Intl.NumberFormat("fr-FR", {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     }).format(text || 0);
    //     return `${formattedPrice} ${record.docCur || ""}`;
    //   },
    // },
    {
      title: "Jami",
      dataIndex: "lineTotal",
      key: "lineTotal",
      width: 150,
      render: (text, record) => {
        const formattedTotal = new Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(text || 0);
        return `${formattedTotal} ${record.docCur || ""}`;
      },
    },
  ];

  const totalSum = modalData.reduce((sum, item) => {
    return sum + (item.totalFrgn || 0);
  }, 0);

  const totalQty = modalData.reduce((sum, item) => {
    return sum + (item.qty || 0);
  }, 0);

  const totalLineTotal = modalData.reduce((sum, item) => {
    return sum + (item.lineTotal || 0);
  }, 0);

  const summary = (pageData) => {
    if (modalData.length <= 1) return null;

    return (
      <Table.Summary fixed>
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <strong>Jami:</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1} colSpan={1}>
            <strong>
              {new Intl.NumberFormat("fr-FR").format(totalQty)}{" "}
              {headerData?.buyUnitMsr || ""}
            </strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2} colSpan={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={3} colSpan={1}>
            <strong>
              {new Intl.NumberFormat("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(totalLineTotal)}{" "}
              {headerData?.docCur || ""}
            </strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    );
  };

  return (
    <Modal
      title={
        <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
          Hujjat № {headerData.docNum}
        </h1>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="50%"
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
    >
      <div className="w-full px-4 sm:px-5">
        <div className="w-full">
          <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4">
            <div className="flex flex-col gap-3">
              <p className="font-medium">Yetkazib beruvchi:</p>
              <Input
                type="text"
                value={headerData.cardName || "-"}
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Partiya raqami:</p>
              <Input
                type="text"
                value={headerData.partyNumber || "-"}
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Transport raqami:</p>
              <Input
                type="text"
                value={headerData.u_numberOfTransport || "-"}
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Yo'nalish turi:</p>
              <Input
                type="text"
                value="To'g'ridan to'g'ri"
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Transport turi:</p>
              <Input
                type="text"
                value={data.U_typeOfTransport || "-"}
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Hujjat raqami:</p>
              <Input
                type="text"
                value={headerData.docNum || "-"}
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Sana:</p>
              <Input
                type="text"
                value={
                  headerData.docDate
                    ? moment(headerData.docDate).format("DD-MM-YYYY")
                    : "-"
                }
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-medium">Tugash sanasi:</p>
              <Input
                type="text"
                value={
                  headerData.docDueDate
                    ? moment(headerData.docDueDate).format("DD-MM-YYYY")
                    : "-"
                }
                style={{ color: "black" }}
                className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                disabled
              />
            </div>
          </div>

          <Table
            columns={columns}
            dataSource={modalData}
            pagination={false}
            loading={loading}
            className="border-1 mt-4 w-full border-black sm:mt-12"
            scroll={{ x: "100%" }}
            rowKey={(record, index) => index}
            summary={summary}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DirectModal;
